// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modal_container":"Modal_modal_container__WtfSn"};